import Plannings from "./plannings.coffee"
import SavePlannings from "./save_plannings.coffee"

$(document).on 'turbolinks:load', ->
  new Plannings.add_listeners()
  new SavePlannings().handler_events()
